<template>
    <div>
        <div class="acontent" v-if="adviseList.length != 0">
            <div class="root-reply-container" v-for="(item, i) in adviseList" :key="i">
                <div class="root-reply-avatar">
                    <img :src="item.msgLogo ? item.msgLogo : '../../assets/icon/组 74(1).png'
                        " alt="" />
                </div>
                <div class="content-warp">
                    <div class="user-info">
                        <p class="user-name">{{ item.msgTitle }}</p>
                    </div>
                    <div class="root-message">
                        <p class="root-reply" v-html="item.msgContent"></p>
                        <div class="root-logo">
                            <div class="logos" v-for="items in item.imgList" :key="items.attachmentId"
                                >
                                <!-- <img :src="items.url" /> -->
                                <span class="fileIcon"><svg viewBox="0 0 48 48" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" stroke="currentColor"
                                        class="arco-icon arco-icon-file-audio" stroke-width="4" stroke-linecap="butt"
                                        stroke-linejoin="miter">
                                        <path d="M37 42H11a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h21l7 7v27a2 2 0 0 1-2 2Z"></path>
                                        <path d="M25 30a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" fill="currentColor" stroke="none">
                                        </path>
                                        <path
                                            d="M25 30a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm0 0-.951-12.363a.5.5 0 0 1 .58-.532L30 18">
                                        </path>
                                    </svg></span>
                                <p class="fileName" @click="deait(items.url)"> 文件名: {{ items.name }}</p>
                            </div>
                        </div>
                        <p class="reply-info">
                            <span class="reply-time">{{ geshu(item.createTime) }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="page">
            <el-pagination background :current-page.sync="queryParam.page" :page-size.sync="queryParam.size"
                @current-change="CurrentChange" layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
        </div>
      

        <el-empty v-else description="暂无内容"></el-empty>

    </div>
</template>

<script>
import api from "../../api";
import * as moment from "moment";
export default {
    data() {
        return {
            adviseList: [],
            queryParam: {
                page: 1,
                size: 10,
            },
            total: 0,
        };
    },
    created() {
        this.getMessage();
    },
    methods: {
        geshu(createTime) {
            return moment(createTime).format("YYYY-MM-DD HH:mm:ss");
        },
        // 获取管理员通知
        getMessage() {
            api.getmsgsList(this.queryParam).then(async (res) => {
                // this.adviseList = res.data.list;
                let xinArr = res.data.list.map(async (item) => {
                    await api.getqueryByMsgId({ msgId: item.msgId }).then((res) => {
                        console.log(res.data, "我跑不掉了");
                        item.imgList = res.data;
                    });
                    console.log(item, "我不是itme");
                    return item;
                });

                await Promise.all(xinArr).then((ress) => {
                    this.adviseList = ress;
                    this.total = res.data.total;
                });
            });
        },
        timestampToTime(timestamp) {
            let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = date.getFullYear() + "年";
            let M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "月";
            let D =
                (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日";
            return Y + M + D;
        },
        CurrentChange() {
            this.getMessage();
        },
        // 查看附件
        deait(url) {
            window.open(url);
        },
    },
};
</script>

<style lang="scss" scoped>
.acontent {
    .root-reply-container {
        padding: 22px 0 0px 80px;
        display: flex;

        .root-reply-avatar {
            margin-right: 20px;
            width: 54px;
            height: 54px;
            border-radius: 50%;
            overflow: hidden;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .content-warp {
            flex: 1;
            padding-bottom: 8px;
            border-bottom: 1px solid #eaebed;
        }

        .user-info {
            .user-name {
                font-family: PingFang SC, HarmonyOS_Medium, Helvetica Neue,
                    Microsoft YaHei, sans-serif;
                font-weight: 500;
                margin-right: 5px;
                color: rgb(251, 114, 153);
                cursor: pointer;
                font-size: 13px;
            }
        }

        .root-message {
            .root-reply {
                font-weight: 400;
                box-sizing: border-box;
                color: rgb(24, 25, 28);
                overflow: hidden;
                word-wrap: break-word;
                word-break: break-word;
                white-space: pre-wrap;
                line-height: 24px;
                vertical-align: baseline;
                font-size: 15px;
                text-indent: 2em;
                margin: 0px;
                padding: 0px;

                p {
                    margin: 0px;
                    padding: 0px;
                }
            }

            .root-logo {


                .logos {
                    display: flex;
                    align-items: center;
                    flex-wrap: nowrap;
                    align-items: center;
                    box-sizing: border-box;
                    width: 100%;
                    padding: 8px 10px;
                    margin-bottom: 12px;
                    overflow: hidden;
                    font-size: 14px;
                    background-color: rgb(250, 250, 250);
                    border-radius: 6px;
                    transition: background-color .1s cubic-bezier(0, 0, 1, 1);
                    color: #00bcd4;
                    .fileIcon {
                        display: inline-block;
                        width: 1em;
                        height: 1em;
                        color: inherit;
                        font-style: normal;
                        vertical-align: -2px;
                        outline: none;
                        stroke: currentColor;
                      
                        margin-right: 20px;
                    }

                    .fileName {
                        overflow: hidden;                   
                        text-decoration: none;
                        text-overflow: ellipsis;
                        cursor: pointer;
                    }


                }
            }

            .reply-info {
                .reply-time {
                    color: rgb(148, 153, 160);
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 24px;
                    margin-right: 20px;
                }
            }
        }
    }
}

p {
    margin: 0px;
    padding: 0px;
}

.page {
    margin-top: 25px;
    display: flex;
    justify-content: center;
}
</style>